<template>
  <div class="calc-summary__card">
    <div class="calc-summary__header">
      <slot />
    </div>
    <div class="calc-summary__options">
      <div
        v-for="(option, index) in calculationOptions"
        :key="index"
        class="calc-summary__option-row"
      >
        <p class="calc-summary__label">
          <span v-if="option.affectingFactor" class="calc-summary__required-mark">●</span>
          {{ option.title }}
        </p>
        <p class="calc-summary__value">{{ option.value }}</p>
      </div>

      <div
        v-if="price"
        class="calc-summary__price"
      >
        <Divider type="horizontal" />
        <p class="calc-summary__price-title">
          Загальна вартість
        </p>

        <div
          v-if="hasDiscount"
          class="calc-summary__discount-group"
        >
          <p class="calc-summary__price-discount calc-summary__price--original">
            {{ formatNumber(displayOriginalPrice, { hideDecimalIfZero: true, precision: 2 }) }}
            <span class="calc-summary__price-discount--currency">₴</span>
          </p>
          <span
            v-if="showDiscountBadge"
            class="calc-summary__discount-badge"
          >
            -{{ formatNumber(discount, { hideDecimalIfZero: true, precision: 2 }) }} ₴
          </span>
        </div>

        <p :class="clsx('calc-summary__price', { 'calc-summary__price--discounted': hasDiscount })">
          {{ formatNumber(price, { hideDecimalIfZero: true, precision: 2 }) }}
          <span :class="clsx('calc-summary__price--currency', { 'calc-summary__price--currency-discounted': hasDiscount })">₴</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import { NumberFormatter } from '@/shared/lib/number';
import { Divider } from '@/shared/ui/divider';

const { formatNumber } = NumberFormatter();

export default {
  props: {
    calculationOptions: {
      type: Array,
      required: true,
    },
    price: {
      type: [String, Number],
      default: null,
    },
    originalPrice: {
      type: [String, Number],
      default: null,
    },
    discount: {
      type: [String, Number],
      default: null,
    },
    showDiscountBadge: {
      type: Boolean,
      default: true,
    },
  },
  components: { Divider },
  computed: {
    hasDiscount() {
      const discountValue = Number(this.discount);
      return !isNaN(discountValue) && discountValue > 0;
    },
    displayOriginalPrice() {
      if (this.originalPrice != null) {
        return Number(this.originalPrice);
      }
      if (this.hasDiscount) {
        const price = Number(this.price);
        const discount = Number(this.discount);
        return !isNaN(price) && !isNaN(discount) ? price + discount : null;
      }
      return null;
    },
  },
  methods: {
    formatNumber,
    clsx,
  },
};
</script>

<style scoped lang="scss">
.calc-summary {
  &__card {
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.06), 0 1px 3px 0 rgb(0 0 0 / 0.1);
  }

  &__header {
    margin-bottom: 16px;
  }

  &__options {
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 16px;
  }

  &__option-row {
    & + & {
      margin-top: 16px;
    }
  }

  &__label {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: #717680;
    margin: 0 0 4px;
  }

  &__value {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }

  &__required-mark {
    color: #ff3b30;
    margin: 0 4px 4px 0;
  }

  &__price-title {
    font-size: 16px;
    font-weight: 500;
    color: #09090B;
    margin: 0 0 8px;
  }

  &__price {
    font-size: 30px;
    font-weight: 600;
    color: #FB923C;
    margin: 0;

    &--currency {
      font-size: 20px;
      font-weight: 400;
      color: #FB923C;
    }

    &--currency-discounted {
      color: #FF3B30;
    }

    &--original {
      font-size: 16px;
      font-weight: 400;
      color: #717680;
      text-decoration: line-through;
      margin: 0 0 4px;

      .calc-summary__price--currency {
        font-size: 14px;
        color: #717680;
      }
    }

    &--discounted {
      color: #FF3B30;
    }
  }

  &__discount-group {
    display: flex;
  }

  &__discount-badge {
    display: inline-block;
    background: #FF3B30;
    color: #fff;
    border-radius: 12px;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 500;
    margin: 0 0 8px 8px;
  }
}
</style>
